<tui-tag *ngIf="!!text && !!color" class="color_{{ color }}" status="custom" size="l" [value]="text || '123'"></tui-tag>
